import * as React from "react";
const SvgSectionCollapseIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M6 3L9.82322 6.82322C9.92085 6.92085 10.0791 6.92085 10.1768 6.82322L14 3" stroke="#808080" strokeLinecap="round" /><path d="M6 17L9.82322 13.1768C9.92085 13.0791 10.0791 13.0791 10.1768 13.1768L14 17" stroke="#808080" strokeLinecap="round" /></svg>;
export default SvgSectionCollapseIcon;